import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BankDetailService } from 'src/app/services/bank-details.service';
import { ChallanService } from 'src/app/services/challan-services.service';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-solar-challan',
  templateUrl: './solar-challan.component.html',
  styleUrls: ['./solar-challan.component.scss']
})
export class SolarChallanComponent implements OnInit {
  public farmerId: any;
  public farmerMobile: string;
  public farmerAppDetails: any;
  public selectedFarmerDeatils: any;
  public selectedAppId: any;

  public filteredAppId: any;
  public dataRecieved: boolean = false;
  public challanData: any;

  public currentDate: Date;


  constructor(
    public dashboard: DashboardService,
    public productService: BankDetailService,
    private challanMIService: ChallanService,
    private messageService: MessageService,
    private activityRecordService : ActivityRecordService,
    private loader: AppLoaderService

  ) { }

  ngOnInit(): void {
    this.farmerMobile = sessionStorage.getItem('farmerPh');
    this.farmerId = sessionStorage.getItem('farmerId');
    this.getApplicationIdsForSolarChallan(this.farmerId)
  }

  getApplicationIdsForSolarChallan(farmerId) {
    let mobile = sessionStorage.getItem('farmerPh') ? sessionStorage.getItem('farmerPh') : '';
    this.loader.start();
    this.challanMIService
      .getApplicationIdsForSolarChallan(farmerId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.activityRecordService.activityRecord(mobile, 'Solar Challan', farmerId, new Date(), 'Success');
          
          this.farmerAppDetails = res;
          this.loader.close();
          console.log("farmerAppDetails", this.farmerAppDetails);
        },
        error: (err) => {
          this.activityRecordService.activityRecord(mobile, 'Solar Challan', farmerId, new Date(), err);
          this.loader.close();
          console.log("error", err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectAppId(){
    console.log("selected farmer details", this.selectedFarmerDeatils);
    this.selectedAppId = this.selectedFarmerDeatils;
    console.log("selected app ID", this.selectedAppId);

    this.getSolarChallan(this.selectedAppId);
  }

  getSolarChallan(id) {
    let mobile = sessionStorage.getItem('farmerPh') ? sessionStorage.getItem('farmerPh') : '';
    this.loader.start();
    this.challanMIService
      .getSolarChallan(id)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.activityRecordService.activityRecord(mobile, 'Solar Challan Details', id, new Date(), 'Success');
      
          console.log('challan Data', data);
          this.challanData = data;
          this.loader.close();
          this.currentDate = new Date();
          this.dataRecieved = true;
        },
        error: (err) => {
          this.activityRecordService.activityRecord(mobile, 'Solar Challan Details', id, new Date(), err);
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Challan not loaded.',
          });
        },
      });
  }

  onPrint(divName){
    document.body.style.visibility="hidden";
    document.getElementById(divName).style.visibility='visible'
    document.getElementById('select_app_solor_card').style.display='none'
    window.print();
    document.getElementById('select_app_solor_card').style.display='block'
    document.body.style.visibility="visible";
  }
}
